import { describeFields } from '../common/fields';
import { SchoolSchema } from './schemas';

export const SCHOOL_FIELDS = describeFields(SchoolSchema, {
  id: {},
  label: {},
  shortLabel: {},
  abbreviation: {},
  type: {},
  hscRank: {},
  address: {},
});
